import {Box, Grid, SectionIntroStacked} from '@primer/react-brand/esm'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import {renderWithoutParagraphs} from '../../../../utils'
import type {IntroSectionProps} from '../types'

type Props = Pick<IntroSectionProps, 'introContextHeading' | 'introContextBody' | 'introContextLink' | 'introItems'>

export function IntroSimpleIntro({introContextHeading, introContextBody, introContextLink, introItems}: Props) {
  if (!introContextHeading && !introContextBody) return null

  return (
    <Box marginBlockStart={{narrow: 48, regular: 80}} marginBlockEnd={{narrow: 48, regular: 80}}>
      <Grid>
        <Grid.Column>
          <SectionIntroStacked>
            {introContextHeading ? (
              <SectionIntroStacked.Heading>{renderWithoutParagraphs(introContextHeading)}</SectionIntroStacked.Heading>
            ) : null}
            {introContextBody ? (
              <SectionIntroStacked.Description>
                {renderWithoutParagraphs(introContextBody)}
              </SectionIntroStacked.Description>
            ) : null}
            {introContextLink?.fields.href && (
              <SectionIntroStacked.Link href={introContextLink.fields.href}>
                {introContextLink.fields.text}
              </SectionIntroStacked.Link>
            )}
            {introItems && introItems.length > 0 ? (
              <SectionIntroStacked.Items>
                {introItems.map(item => {
                  const isIconItem = item.sys.contentType.sys.id === 'iconLinkItem'
                  const IconComponent = isIconItem && 'icon' in item.fields ? getPrimerIcon(item.fields.icon) : null
                  return (
                    <SectionIntroStacked.Item key={item.sys.id}>
                      {IconComponent ? <SectionIntroStacked.ItemIcon icon={<IconComponent />} /> : null}
                      <SectionIntroStacked.ItemHeading>
                        {renderWithoutParagraphs(item.fields.heading)}
                      </SectionIntroStacked.ItemHeading>
                      <SectionIntroStacked.ItemDescription>
                        {renderWithoutParagraphs(item.fields.description)}
                      </SectionIntroStacked.ItemDescription>
                    </SectionIntroStacked.Item>
                  )
                })}
              </SectionIntroStacked.Items>
            ) : null}
          </SectionIntroStacked>
        </Grid.Column>
      </Grid>
    </Box>
  )
}
